module.exports = __webpack_public_path__ + "img/users.fcd0300a.svg";